/* eslint-disable no-unused-vars */
import React, {
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
  useRef,
} from "react";
import $ from "jquery";

import UploadImageToS3WithPhp from "../../lib/UploadImageToS3WithPhp";
import BuddibleSocket, { MsgIDList } from "../../lib/BuddibleSocket";
import Utilities from "../../lib/Utilities";
import CodeList from "../../lib/CodeList";

window.jQuery = $;
window.$ = $;
global.jQuery = $;
const socket = new BuddibleSocket();
const util = new Utilities();
const codeList = new CodeList();

const uiData = {
  mainTitle: "프로모션 관리",
  type: "프로모션",
};

const EDIT_TYPE = {
  UPDATE: "UPDATE",
  INSERT: "INSERT",
  DELETE: "DELETE",
};

function PromotionManageEdit(props, ref) {
  const { data = {} } = props;
  const [userData, setUserData] = useState({});
  const [loading, setLoading] = useState(false);
  const [uploadFiles, setUploadFiles] = useState("");

  const $controllers = {
    prIDX: useRef(),
    prTITLE: useRef(),
    prCONTENTS: useRef(),
    prFiles: useRef(),
    prUSEYN: useRef(),
  };

  const serverFile = {
    update: "/promotion/JS_promotion_update.php",
    insert: "/promotion/JS_promotion_insert.php",
  };

  const dataChange = (e, params) => {
    setUserData(params);
  };

  useEffect(() => {
    if (userData.hasOwnProperty("currentData")) {
      $controllers.prIDX.current.value = userData.currentData.prIDX;
      $controllers.prIDX.current.disabled = true;
      $controllers.prTITLE.current.value = userData.currentData.prTITLE;
      $controllers.prCONTENTS.current.value = userData.currentData.prCONTENTS;
      $controllers.prFiles.current.value = userData.currentData.prFiles;
      $controllers.prUSEYN.current.value = userData.currentData.prUSEYN;
      setUploadFiles(userData.currentData.prFiles);
    } else {
      $controllers.prIDX.current.value = "";
      $controllers.prIDX.current.disabled = true;
      $controllers.prTITLE.current.value = "";
      $controllers.prCONTENTS.current.value = "";
      $controllers.prFiles.current.value = "";
      $controllers.prUSEYN.current.value = "";
      setUploadFiles("");
    }
  }, [userData]);

  useEffect(() => {
    socket.addLocalEventListener(
      MsgIDList.EVENT_SOCKET_DATA_ERROR,
      "PromotionManageEdit",
      (b, n) => {
        setLoading(false);
      }
    );

    socket.addLocalEventListener(
      MsgIDList.EVENT_PROMOTION_MANAGE_EDIT_MODAL_CALL,
      "PromotionManageEdit",
      (b, n) => {
        setUserData({});
      }
    );
    return () => {
      socket.removeLocalEventListener(
        MsgIDList.EVENT_SOCKET_DATA_ERROR,
        "PromotionManageEdit"
      );

      socket.removeLocalEventListener(
        MsgIDList.EVENT_PROMOTION_MANAGE_EDIT_MODAL_CALL,
        "PromotionManageEdit"
      );
    };
  }, []);

  useImperativeHandle(ref, () => ({
    openModal(e, params) {
      //console.log(props);
      dataChange(e, params);
    },
    removeData(e, params) {
      DeleteData(e, params);
    },
  }));

  //첨부파일 업로드
  const UploadFiles = (val) => {
    if (val.ret) {
      let fileLink = val.fileName;
      let fileName = val.realFileName;
      let fileFull = `${fileName}?${fileLink}`;
      let fileList = uploadFiles !== "" ? uploadFiles.split("|") : [];
      fileList.push(fileFull);
      let setFiles = fileList.join("|");
      $controllers.prFiles.current.value = setFiles;
      setUploadFiles(setFiles);
    } else {
      codeList.Modal.current.alert(
        "업로드 중 문제가 발생하였습니다. 관리자에게 문의 바랍니다.",
        () => {}
      );
    }
  };

  //첨부파일 삭제
  const deleteFile = (url, name) => {
    let splitData = uploadFiles.split("|");
    let index = splitData.findIndex((item) => {
      // console.log(item, `${name}:${url}`, item === `${name}:${url}`);
      return item === `${name}?${url}`;
    });

    if (index > -1) {
      splitData.splice(index, 1);
      const pmFiles = splitData.join("|");
      // console.log(pmFiles);
      $controllers.prFiles.current.value = pmFiles;
      setUploadFiles(pmFiles);
    }
  };

  const DeleteData = (e, params) => {
    let delData = {
      prIDX: params.currentData.prIDX,
      prDelYN: "Y",
    };
    codeList.Modal.current.confirm(
      `해당 ${uiData.type}을 삭제하시겠습니까?`,
      (ret) => {
        if (ret) {
          requestUserUpdate(delData, EDIT_TYPE.UPDATE);
        }
      }
    );
  };

  const actionSave = (e) => {
    setLoading(true);
    if (checkValidation()) {
      let updateData = {
        prIDX: $controllers.prIDX.current.value,
        prTITLE: $controllers.prTITLE.current.value,
        prCONTENTS: $controllers.prCONTENTS.current.value,
        prFiles: $controllers.prFiles.prFiles,
        prUSEYN: $controllers.prUSEYN.current.value,
        prDelYN: "N",
      };

      requestUserUpdate(
        updateData,
        $controllers.prIDX.current.value.trim() !== ""
          ? EDIT_TYPE.UPDATE
          : EDIT_TYPE.INSERT
      );
    } else {
      setLoading(false);
    }
  };

  const checkValidation = () => {
    if ($controllers.prTITLE.current.value.trim() === "") {
      codeList.Modal.current.alert("제목을 입력해주세요", () => {});
      return false;
    }
    if ($controllers.prCONTENTS.current.value.trim() === "") {
      codeList.Modal.current.alert("내용을 입력해주세요", () => {});
      return false;
    }

    if ($controllers.prUSEYN.current.value.trim() === "") {
      codeList.Modal.current.alert("사용여부를 선택해주세요", () => {});
      return false;
    }

    return true;
  };

  const requestUserUpdate = (updateData, TYPE = EDIT_TYPE.UPDATE) => {
    let msgID = util.makeUUIDv4();
    let socketMsg = {
      file: TYPE === EDIT_TYPE.UPDATE ? serverFile.update : serverFile.insert,
      msgID: msgID,
      data: {},
      ...updateData,
    };
    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["ret"] === true) {
          setLoading(false);
          socket.sendLocalMessage(
            TYPE === EDIT_TYPE.UPDATE
              ? MsgIDList.EVENT_PROMOTION_MANAGE_DATA_UPDATED
              : MsgIDList.EVENT_PROMOTION_MANAGE_DATA_UPDATED,
            "PromotionManageEdit",
            newData,
            () => {}
          );
          TYPE === EDIT_TYPE.UPDATE
            ? codeList.Modal.current.alert(
                `${uiData.type}을 업데이트 하였습니다.`,
                () => {}
              )
            : codeList.Modal.current.alert(
                `${uiData.type}을 추가 하였습니다.`,
                () => {}
              );

          $("#closePromotionEdit").click();
        } else {
          setLoading(false);
          TYPE === EDIT_TYPE.UPDATE
            ? codeList.Modal.current.alert(
                `${uiData.type} 업데이트 중 오류가 발생하였습니다.`,
                () => {}
              )
            : codeList.Modal.current.alert(
                `${uiData.type} 추가 중 오류가 발생하였습니다.`,
                () => {}
              );
        }
      }
    });
  };

  const Cancel = () => {
    $controllers.prIDX.current.value = "";
    $controllers.prIDX.current.disabled = true;
    $controllers.prTITLE.current.value = "";
    $controllers.prCONTENTS.current.value = "";
    $controllers.prFiles.current.value = "";
    $controllers.prUSEYN.current.value = "";
    setUploadFiles("");
    $("#closePromotionEdit").click();
  };

  return (
    <>
      <div
        className="modal fade"
        id="staticPromotionEditModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-labelledby="staticPromotionEditModal"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ maxWidth: 700 }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title" id="staticBackdropLabel">
                <strong>{uiData.mainTitle}</strong>
              </h3>
              <button
                type="button"
                className="btn btn-danger"
                data-dismiss="modal"
                aria-label="Close"
                id="closePromotionEdit"
              >
                <i className="fas fa-plus fa-times" />
              </button>
            </div>
            <div className="modal-body">
              <div className="mb-3 row">
                <label className="col-form-label col-sm-3 text-end">
                  관리 번호
                </label>
                <div className="col-sm-9">
                  <input
                    type="account"
                    className="form-control"
                    placeholder="ID"
                    ref={$controllers.prIDX}
                  />
                </div>
              </div>

              <div className="mb-3 row">
                <label className="col-form-label col-sm-3 text-end">제목</label>
                <div className="col-sm-9">
                  <textarea
                    className="form-control"
                    rows="3"
                    ref={$controllers.prTITLE}
                  />
                </div>
              </div>

              <div className="mb-3 row">
                <label className="col-form-label col-sm-3 text-end">내용</label>
                <div className="col-sm-9">
                  <textarea
                    className="form-control"
                    rows="15"
                    ref={$controllers.prCONTENTS}
                  />
                </div>
              </div>
              <div className="mb-3 row">
                <label className="col-form-label col-sm-3 text-end">
                  파일첨부
                </label>

                <div className="col-sm-9">
                  {" "}
                  <UploadImageToS3WithPhp
                    region={"mall/promotion"}
                    callback={UploadFiles}
                  />
                  <input
                    className="form-control d-none"
                    disabled={true}
                    type="text"
                    ref={$controllers.prFiles}
                  />
                  {uploadFiles !== "" &&
                    uploadFiles.split("|").map((v, i) => {
                      let splitData = v.split("?");
                      if (splitData.length === 1) return null;
                      let fileName = splitData[0];
                      let fileLink = splitData[1];
                      return (
                        <div className="my-2" key={v}>
                          {/* <button
                                onClick={() => {\
                                  downloadAs(fileLink, fileName);
                                }}
                              >
                                {fileName}
                              </button>*/}
                          <button
                            className="btn btn-danger mr-2"
                            onClick={() => {
                              deleteFile(splitData[0], fileName);
                            }}
                          >
                            삭제
                          </button>
                          {fileName.endsWith(".pdf") && (
                            <a
                              className="font-weight-bold text-decoration-underline"
                              onClick={(e) => {
                                e.preventDefault();
                                util.downloadAs(fileLink, fileName);
                              }}
                            >
                              {fileName}
                            </a>
                          )}
                          {!fileName.endsWith(".pdf") && (
                            <a
                              className="font-weight-bold text-decoration-underline"
                              onClick={(e) => {
                                e.preventDefault();
                                util.downloadAs(fileLink, fileName);
                              }}
                            >
                              {fileName}
                            </a>
                          )}
                        </div>
                      );
                    })}
                </div>
              </div>
              <div className="mb-3 row">
                <label className="col-form-label col-sm-3 text-end">
                  사용유무
                </label>
                <div className="col-sm-9">
                  <select
                    className="custom-select form-control"
                    ref={$controllers.prUSEYN}
                  >
                    <option value="">미선택</option>
                    <option value="Y">사용</option>
                    <option value="N">중지</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                id="btnCloseModal"
                onClick={(e) => {
                  codeList.Modal.current.confirm(
                    `${uiData.type}등록을 취소하시겠습니까?`,
                    (ret) => {
                      if (ret) {
                        Cancel();
                      }
                    }
                  );
                }}
              >
                <i className="fa fa-times mr-2" />
                취소
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={(e) => actionSave(e)}
                disabled={loading}
              >
                <i className="fa fa-check mr-2" />
                저장
                {loading && (
                  <span
                    className="spinner-border spinner-border-sm ml-2"
                    role="status"
                    aria-hidden="true"
                  />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default forwardRef(PromotionManageEdit);
